import React from "react"
import { useDispatch, useSelector } from "react-redux"

import { applyFilters } from "../../store/rankings.actions"
import { getActiveFilters, getWHWFilterData } from "../../store/rankings.selectors"
import { AwardsYearFilterBox } from "../../styles"
import SelectInput from "../filters/selectInput"

const AwardsYearFilter = () => {
  const dispatch = useDispatch()
  const appliedFilters = useSelector(getActiveFilters)
  const filters = useSelector(getWHWFilterData)?.year

  const handleSubmit = e => {
    dispatch(applyFilters({ year: e }))
  }

  if (!filters) return null

  return (
    <AwardsYearFilterBox>
      <SelectInput
        options={{
          id: "filter-year",
          label: "Year",
          items: filters || []
        }}
        isLoading={filters?.isLoading}
        filterValue={appliedFilters.year}
        onFilter={handleSubmit}
      />
    </AwardsYearFilterBox>
  )
}

export default AwardsYearFilter
